import { Chains } from 'modules/blockChain/chains'
import * as generated from 'generated'
import { createContractHelpers } from 'modules/contracts/utils/createContractHelpers'

export const ContractUSDC = createContractHelpers({
  name: 'USDC',
  factory: generated.IERC20__factory,
  address: {
    [Chains.Matic]: '0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174',
    [Chains.Polygon]: '0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174',
  },
})

export const ContractWETH = createContractHelpers({
  name: 'WETH',
  factory: generated.IERC20__factory,
  address: {
    [Chains.Matic]: '0x7ceB23fD6bC0adD59E62ac25578270cFf1b9f619',
    [Chains.Polygon]: '0x7ceB23fD6bC0adD59E62ac25578270cFf1b9f619',
  },
})

export const ContractPriceFeed = createContractHelpers({
  name: 'PriceFeed',
  factory: generated.PriceFeed__factory,
  address: {
    [Chains.Matic]: '0x89feAbC55CDb96Dd3C578883fE496f3bD3D83f46',
    [Chains.Polygon]: '0x89feAbC55CDb96Dd3C578883fE496f3bD3D83f46',
  },
})
